export default {
  created () {
    this.loadScript()
  },
  data () {
    return {
      isScriptLoaded: false,
      script: null
    }
  },
  methods: {
    /**
     * Opens paystack inline payment iframe
     *
     * @param payload paystack options to load the inline sdk with
     * @param initCallback {Function} optional callback function that returns a reference to the paystack handler
     * */
    async pay (payload, initCallback = null) {
      const customFields = payload.custom_fields || [];
      const metaData = payload.meta_data || {};
      let handler = null;
      const payableAmount = (this.totalTransactionAmount(payload.amount) * 100);
      return new Promise((resolve, reject) => {
        handler = window.PaystackPop.setup({
          ...payload,
          key: process.env.VUE_APP_PAYSTACK_PUBLIC_KEY,
          email: payload.customer_email,
          amount: payableAmount,
          currency: payload.currency || 'NGN',
          metadata: {
            ...metaData,
            custom_fields: [
              {
                display_name: 'User ID',
                variable_name: 'user_id',
                value: payload.user_id
              },
              ...customFields
            ]
          },
          callback: function (response) {
            if (response.status !== 'success') {
              return reject(response)
            }

            resolve(response)
          },
          onClose: function () {
            reject()
          }
        });
        handler.openIframe();
        if(initCallback) {
          initCallback.call(this, {
            handler,
          });
        }
      });
    },
    /**
     * Returns the total transaction amount payable by the customer
     * which includes additional paystack charges capped to a max of 2000
     * @param transactionAmount {number} The original transaction amount
     * @return number
     * */
    totalTransactionAmount(transactionAmount) {
      const decimalFee = 0.0150;
      const feeCap = 2000;
      const flatFee = 100;

      const calculateFor2500Below = (amount) => {
        const applicableFees = decimalFee * amount;
        if (applicableFees > feeCap) {
          return (amount + feeCap);
        }
        return ((amount / (1 - decimalFee)) + 0.001);
      }

      const calculateFor2500Above = (amount) => {
        const applicableFees = decimalFee * amount;
        if (applicableFees > feeCap) {
          return (amount + feeCap);
        }
        return (((amount + flatFee) / (1 - decimalFee)) + 0.001);
      }

      if (transactionAmount < 100) {
        return parseFloat((transactionAmount + 1).toFixed(2));
      } else if (transactionAmount < 2500) {
        return parseFloat(calculateFor2500Below(transactionAmount).toFixed(2));
      }
      return parseFloat(calculateFor2500Above(transactionAmount).toFixed(2));
    },
    async loadScript () {
      if (this.scriptLoaded()) {
        return
      }

      this.script = document.createElement('script')

      this.script.onload = () => {
        this.isScriptLoaded = true
      }

      this.script.async = true

      this.script.setAttribute('src', process.env.VUE_APP_PAYSTACK_INLINE_URL)

      document.head.appendChild(this.script)
    },
    scriptLoaded () {
      return (
        this.isScriptLoaded ||
        document.head.querySelectorAll(
          `script[src="${process.env.VUE_APP_PAYSTACK_INLINE_URL}"]`
        ).length > 0
      )
    }
  }
}
